import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col } from 'react-bootstrap';
import { PrimaryButton } from '../../components/buttons/PrimaryButton';
import { SelectInput } from '../../components/inputs/Select';
import { Calendar } from 'primereact/calendar';
import { editSpecialCase, getSpecialCases, setDisplaySpecialCaseModalDetails, setSpecialCaseModalData, setSpecialCases } from '../../components/collabs/collabsSlice';
import { getVarFormattedDate, showErrorToast, showSuccessToast } from '../../app/utils/helpers';
import Langs from '../../app/lang/langs';
import { DynamicButton } from '../../components/buttons/DynamicButton';
import { Dropdown } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';

export default function SpecialCaseDetailsDialog() {
  const dispatch = useDispatch();
  const visible = useSelector((state) => state.collabs.displaySpecialCaseModalDetails)
  const specialCaseData = useSelector((state) => state.collabs.specialCaseModalData)
  const allCollabs = useSelector((state) => state.collabs.allCollabsList)
  const specialCasesOptions = useSelector((state) => state.collabs.specialCasesOptions)

  const [tempStartDate, setTempStartDate] = useState(null);
  const [tempEndDate, setTempEndDate] = useState(null);
  const [tempCase, setTempCase] = useState(null);
  const [tempCollab, setTempCollab] = useState(null);
  const [tempComments, setTempComments] = useState(null);
  const [updateBody, setUpdateBody] = useState({});

  useEffect(() => {
    if (visible) {
      if (specialCaseData.start_date) {
        setTempStartDate(getVarFormattedDate(specialCaseData.start_date, "yyyy-mm-dd"));
      }
      if (specialCaseData.end_date) {
        setTempEndDate(getVarFormattedDate(specialCaseData.end_date, "yyyy-mm-dd"));
      }
      if (specialCaseData.case) {
        setTempCase(specialCaseData.case);
      }
      if (specialCaseData.id_collab) {
        setTempCollab(specialCaseData.id_collab);
      }
      if (specialCaseData.comments) {
        setTempComments(specialCaseData.comments);
      }
      setUpdateBody({ id: specialCaseData.id });
    }
  }, [specialCaseData, visible]);



  const handleClose = () => {
    dispatch(setSpecialCaseModalData({}));
    dispatch(setDisplaySpecialCaseModalDetails(false));
    setUpdateBody({});
  };

  const formatDateForDB = (date) => {
    if (!date) return null;
    const d = new Date(date);
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
  };

  const handleDateChange = (field, value) => {
    if (field === "start_date") {
      const newDate = formatDateForDB(value);
      setTempStartDate(newDate);
    } else if (field === "end_date") {
      const newDate = formatDateForDB(value);
      setTempEndDate(newDate);
    }
  };

  useEffect(() => {
    if (specialCaseData?.start_date !== tempStartDate) {
      setUpdateBody((current) => ({ ...current, start_date: tempStartDate }));
    } else {
      setUpdateBody((current) => {
        const newState = { ...current };
        delete newState.start_date;
        return newState;
      });
    }
  }, [tempStartDate]);

  useEffect(() => {
    if (specialCaseData?.end_date !== tempEndDate) {
      setUpdateBody((current) => ({ ...current, end_date: tempEndDate }));
    } else {
      setUpdateBody((current) => {
        const newState = { ...current };
        delete newState.end_date;
        return newState;
      });
    }
  }, [tempEndDate]);

  useEffect(() => {
    if (specialCaseData?.comments !== tempComments) {
      setUpdateBody((current) => ({ ...current, comments: tempComments }));
    } else {
      setUpdateBody((current) => {
        const newState = { ...current };
        delete newState.comments;
        return newState;
      });
    }
  }, [tempComments]);

  useEffect(() => {
    if (specialCaseData?.case != tempCase) {
      setUpdateBody((current) => ({ ...current, case: tempCase }));
    } else {
      setUpdateBody((current) => {
        const newState = { ...current };
        delete newState.case;
        return newState;
      });
    }
  }, [tempCase]);

  useEffect(() => {
    if (specialCaseData?.id_collab !== tempCollab) {
      setUpdateBody((current) => ({ ...current, id_collab: tempCollab }));
    } else {
      setUpdateBody((current) => {
        const newState = { ...current };
        delete newState.id_collab;
        return newState;
      });
    }
  }, [tempCollab]);

  const handleSave = async () => {
    try {
      if (Object.keys(updateBody).length > 1) {
        const response = await dispatch(editSpecialCase({
          special_case: updateBody
        }));
        if (response.payload.responseData.status === 1) {
          setUpdateBody({});
          showSuccessToast("Cas spécial modifié avec succès.");
          dispatch(getSpecialCases());
          handleClose();
        } else {
          showErrorToast(response.payload.error || "Échec de la modification du cas spécial.");
        }
      }
    } catch (error) {
      console.error("Erreur lors de la modification du cas spécial :", error);
      showErrorToast("Erreur interne du serveur.");
    }
  };

  const renderBody = () => {
    if (visible) {
      return (
        <div className="container p-fluid">
          <Row className="mt-2 mb-4 align-items-center">
            <Col md={4}><strong><Langs str="Collaborateur" /></strong></Col>
            <Col md={8}>
              <Dropdown
                options={allCollabs.map((collab) => ({ label: collab.label, value: collab.id }))}
                value={tempCollab}
                onChange={(e) => setTempCollab(e.value)}
                placeholder="Sélectionnez un collaborateur"
              />
            </Col>
          </Row>

          <Row className="mb-4 align-items-center">
            <Col md={4}><strong><Langs str="Cas" /></strong></Col>
            <Col md={8}>
              <Dropdown
                options={specialCasesOptions}
                value={tempCase ? tempCase : null}
                onChange={(e) => setTempCase(e.value)}
                placeholder="Sélectionnez un cas"
              />
            </Col>
          </Row>

          <Row className="p-fluid mb-4 align-items-center">
            <Col md={4}><strong><Langs str="Date de début" /></strong></Col>
            <Col md={8}>
              <Calendar
                value={tempStartDate ? new Date(tempStartDate) : null}
                onChange={(e) => handleDateChange("start_date", e.value)}
                dateFormat="dd/mm/yy"
                placeholder="Sélectionnez une date"
                showIcon
              />
            </Col>
          </Row>

          <Row className="p-fluid mb-4 align-items-center">
            <Col md={4}><strong><Langs str="Date de fin" /></strong></Col>
            <Col md={8}>
              <Calendar
                value={tempEndDate ? new Date(tempEndDate) : null}
                onChange={(e) => handleDateChange("end_date", e.value)}
                dateFormat="dd/mm/yy"
                placeholder="Sélectionnez une date"
                showIcon
                minDate={tempStartDate ? new Date(tempStartDate) : null}
              />
            </Col>
          </Row>
          <Row className="p-fluid mb-4 align-items-center">
            <Col md={4}><strong><Langs str="Comments" /></strong></Col>
            <Col md={8}>
              <InputTextarea
                value={tempComments}
                onChange={(e) => setTempComments(e.target.value)}
                rows={4}
              />
            </Col>
          </Row>
        </div>
      )
    }
  }

  const footerContent = (
    <div className='row'>
      <div className='col-12 row d-flex justify-content-between'>
        <div className='col-3'>
          <PrimaryButton
            onClick={handleClose}
            title={<Langs str="CLOSE" />}
            active={true}
          />
        </div>
        <div className='col-3'>
          {Object.keys(updateBody).length > 1 && (
            <DynamicButton
              onClick={handleSave}
              title={<Langs str="SAVE" />}
              active={true}
              color="green"
            />
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className="card flex justify-content-center">
      <Dialog
        visible={visible}
        draggable={false}
        position='right'
        modal
        resizable={false}
        header={<Langs str="DÉTAILS DU CAS SPÉCIAL" />}
        footer={footerContent}
        style={{ width: '45rem', height: "100vh", maxHeight: "100%", marginRight: 0 }}
        onHide={handleClose}>
        {renderBody()}
      </Dialog>
    </div>
  );
}
